export const HIGH_PRIORITY = 1500;

export const ELEMENT_WIDTH = 160;

export const DEFAULT_ZOOM_LEVEL = 1;
